




























import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SignaturePad extends Vue {
  @Prop() public value: string
  @Prop({ default: '150px' }) public height!: string

  private oldSign = ''
  private options = {
    penColor: '#228',
    onEnd: () => {
      this.saveData()
    },
  }

  get signaturePad() {
    return this.$refs.signaturePad as any
  }

  private undo() {
    const data = this.signaturePad.toData().length
    if (data >= 1) {
      this.signaturePad.undoSignature()
      this.signaturePad.fromDataURL(this.oldSign)
      this.saveData()
    }
  }

  private clear() {
    this.oldSign = ''
    this.signaturePad.clearSignature()
    this.saveData()
  }

  private mounted() {
    this.oldSign = this.value
    this.$nextTick(() => {
      this.signaturePad.resizeCanvas()
      this.signaturePad.fromDataURL(this.value)
    })
  }

  private saveData() {
    const { isEmpty, data } = this.signaturePad.saveSignature()
    this.$emit('input', isEmpty ? '' : data)
  }
}
